import { useEffect, useRef, useState } from "react";
import { EG_Logo } from "../";
import { Box, Button, CircularProgress, Stack, TextField } from "@mui/material";
import { globalTheme } from "../../styles";
import { AccountCircle } from "@mui/icons-material";
import LockIcon from "@mui/icons-material/Lock";
import { useAuthentication, useSetAuthenticatedEmployee, useIsAuthenticatedEmployee } from "../../hooks";
import { useNavigate } from "react-router-dom";
import { AUTHENTICATED_EMPLOYEE_JWT } from "../../constants";
import { CustomSnackBar } from "../Snackbar";

export const Login = () => {
  const [id, setId] = useState("");
  const [password, setPassword] = useState("");
  const [submitLogin, isSubmitLogin] = useState(false);
  const [isSnackbarOpen, setIsSnackbarOpen] = useState(false);

  const handleCloseSnackbar = () => {
    setIsSnackbarOpen(false);
  };

  useEffect(() => {
    isSubmitLogin(false);
  }, [id, password]);

  const logIn = useAuthentication({ id: id, password: password, enabled: submitLogin });
  // TODO: Add loading state & error state handling
  const { fetchingLogginIn, errorLoggingIn, loginResponse, loginError } = logIn;

  const navigate = useNavigate();
  useIsAuthenticatedEmployee() && window.localStorage.removeItem(AUTHENTICATED_EMPLOYEE_JWT);

  useEffect(() => {
    if (loginResponse && loginResponse?.authenticatedEmployee) {
      useSetAuthenticatedEmployee(loginResponse?.authenticatedEmployee || "");
      navigate("/dashboard");
      // TODO: Find a solution to avoid this extra reload upon login. Note: Reloading to force render authenticated layout from core UI
      window.location.reload();
    }
  }, [loginResponse]);

  const isLoginFormValid = id && password; // condition to ensure the username and passwords are filled

  const handleEnterKey = (e) => {
    if (e.key === "Enter" && isLoginFormValid) {
      isSubmitLogin(true);
    }
  };

  return (
    <Box
      sx={{
        backgroundColor: globalTheme.background,
        height: "100dvh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Stack
        spacing={2}
        justifyContent="center"
        alignItems="center"
        padding={4}
        minWidth={0}
        width="500px"
        minHeight={0}
        sx={{
          backgroundColor: globalTheme.white,
          borderRadius: "8px",
          boxShadow: `0px 0px 20px 9px rgba(0, 0, 0, 0.1)`,
        }}
      >
        <EG_Logo height="150px" width="150px" />
        <Box sx={{ display: "flex", alignItems: "flex-end", width: "100%" }}>
          <AccountCircle sx={{ color: "action.active", mr: 1, my: 0.5 }} />
          <TextField
            id="id"
            label="Id"
            variant="standard"
            fullWidth
            onChange={(e) => setId(e.target.value)}
            onKeyDown={handleEnterKey}
          />
        </Box>
        <Box sx={{ display: "flex", alignItems: "flex-end", width: "100%" }}>
          <LockIcon sx={{ color: "action.active", mr: 1, my: 0.5 }} />
          <TextField
            fullWidth={true}
            id="password"
            label="Password"
            variant="standard"
            type="password"
            onChange={(e) => setPassword(e.target.value)}
            onKeyDown={handleEnterKey}
          />
        </Box>

        <Stack direction="row" alignItems="center">
          <Button variant="contained" onClick={(e) => isSubmitLogin(!submitLogin)} disabled={fetchingLogginIn}>
            Login
          </Button>
          {fetchingLogginIn && <CircularProgress size={18} style={{ marginLeft: "8px" }} />}
        </Stack>
      </Stack>
      <CustomSnackBar open={loginError} message={loginError} autoHideDuration={1200} onClose={handleCloseSnackbar} />
    </Box>
  );
};
